/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-01-23 11:00:04                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-23 11:04:21                               *
 *****************************************************************************/

/* SUMMARY
  * userExportDescriptor: descriptor for data/xlsx mapping
*/

/**
* userExportDescriptor: descriptor for data/xlsx mapping
*
* Ordered like the users table: surname first, as the list is sorted by it. No phone column — unlike
* a technician, a plain EasyTech.User has no phone field and UserListItem renders none, so the tab's
* phone header has nothing behind it.
*
* A "username" column used to lead this list, whose getter was also `e.email` — two columns holding
* the same value in every row. Dropped rather than kept: as implemented they cannot diverge.
*/
export const userExportDescriptor: EasyTech.ExportDescriptor[] = [{
  column: "id",
  columnTranslationKey: "common:export.columns.id",
  // Identifiant technique, demandé pour rapprocher un export d'un autre système. Décoché comme
  // n'importe quelle autre colonne si le lecteur n'en a pas l'usage.
  getter: (e: { id?: string }) => e.id || ""
}, {
  column: "lastname",
  columnTranslationKey: "common:lastName",
  getter: (e: EasyTech.User) => e.lastName || ""
}, {
  column: "firstname",
  columnTranslationKey: "common:firstName",
  getter: (e: EasyTech.User) => e.firstName || ""
}, {
  column: "email",
  columnTranslationKey: "common:email",
  getter: (e: EasyTech.User) => e.email || ""
}, {
  column: "roles",
  columnTranslationKey: "common:roles",
  // A user with no role list threw here and took the whole export down with it, so the join is
  // guarded rather than assuming the API always sends the array.
  getter: (e: EasyTech.User) => (e.roles ?? []).join("/")
}];
/***/
